import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28467c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page-content" }
const _hoisted_2 = { class: "content1" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "imgs" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "imgs" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-compact-left" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "toggleImg" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-compact-right" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "content2 align-center" }
const _hoisted_16 = { class: "content2-con" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content2-top" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "热门目的地"),
  /*#__PURE__*/_createElementVNode("h3", null, "Popular Destinations")
], -1))
const _hoisted_18 = { class: "content2-conn align-center" }
const _hoisted_19 = { class: "left" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "当季热门目的地"),
  /*#__PURE__*/_createElementVNode("span", null, "热门玩法值得你去")
], -1))
const _hoisted_21 = { class: "destination flex-col" }
const _hoisted_22 = { class: "nation" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "right flex-row" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "content3" }
const _hoisted_27 = { class: "content3-con" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content3-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "热门景点"),
  /*#__PURE__*/_createElementVNode("h3", null, "Popular Attractions")
], -1))
const _hoisted_29 = { class: "content3-conn" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "content4" }
const _hoisted_32 = { class: "content4-conn flex-col" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "定制旅行", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "自由·省心·有保障, 好的定制, 可以不贵", -1))
const _hoisted_35 = { class: "content5" }
const _hoisted_36 = { class: "content5-con" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "热门路线"),
  /*#__PURE__*/_createElementVNode("h3", null, "Popular Routes")
], -1))
const _hoisted_38 = { class: "routes" }
const _hoisted_39 = ["title", "onClick"]
const _hoisted_40 = { class: "route-title" }
const _hoisted_41 = { class: "content" }
const _hoisted_42 = { class: "content6" }
const _hoisted_43 = { class: "con" }
const _hoisted_44 = ["src"]

import { defineComponent, onMounted, onUnmounted, reactive, ref, toRefs, computed, } from 'vue';
import { Initdata, Attraction } from '../../types/ContentPages/home';
import { useRouter } from 'vue-router'
import { get } from '../../http/api';
import { jump } from '../../Utils/Common';

const toggleTime = 400; // 轮播图切换时间

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const BASE_URL = process.env.VUE_APP_PICTURE_URL; // 当地玩乐BASE_URL

const router = useRouter()
const { DestinationInfo, Nations, Attractions, routes, headerImgs, feature } = toRefs(reactive(new Initdata()))
const imgIsShow = ref<number>(0);
const MoveEnd = ref<boolean>(true); // 轮播图是否移动结束
const imgTransition = ref<string>(`left ${toggleTime}ms ease`);
const imgStyle = computed(() => {
  return {
    left: `-${(imgIsShow.value + 1) * 1700}px`,
    transition: imgTransition.value,
  }
})

//#region 弹窗
const attractionData = ref<Attraction>();
const attractionDialog = ref<boolean>(false);
const openAttractionDialog = (data: Attraction) => { // 打开景点弹窗
  attractionData.value = data;
  attractionDialog.value = true;
}
const closeAttractionDialog = () => { // 关闭景点弹窗
  attractionData.value = {} as Attraction;
  attractionDialog.value = false;
}

//#endregion


//#region 工具函数

const toggleImgBtnStyle = (index: number): any => { // icon指示器的style
  const style = { background: 'rgba(255, 255, 255, 1)' };
  const headerImgsLength = headerImgs.value.length;
  if (index === imgIsShow.value) {
    return style
  } else if (index === headerImgsLength - 1 && imgIsShow.value === -1) {
    return style
  } else if (index === 0 && imgIsShow.value === headerImgsLength) {
    return style
  } else {
    return '';
  }
}

//#endregion

//#region 切换轮播图

const previousImg = () => { // 点击跳转上一页
  if (MoveEnd.value) {
    imgTransition.value = `left ${toggleTime}ms ease`;
    moveTo(-1)
    rebuildInterval();
    if (imgIsShow.value < 0) {
      awaitAnimation(headerImgs.value.length - 1);
    }
  }
}
const nextImg = () => { // 点击跳转下一页
  if (MoveEnd.value) {
    imgTransition.value = `left ${toggleTime}ms ease`;
    moveTo(1)
    rebuildInterval();
    if (imgIsShow.value === headerImgs.value.length) {
      awaitAnimation(0);
    }
  }
}
const toggleImg = (index: number) => { // 切换顶部图片
  if (MoveEnd.value) {
    imgTransition.value = `left ${toggleTime}ms ease`;
    imgIsShow.value = index;
    rebuildInterval();
  }
}
const awaitAnimation = async (position: number) => { // 等待动画渲染结束，实现轮播图的无缝切换
  setTimeout(() => {
    imgTransition.value = 'none';
    imgIsShow.value = position;
  }, toggleTime);
}
const moveTo = (num: number) => {
  MoveEnd.value = false
  imgIsShow.value += num;
  setTimeout(() => {
    MoveEnd.value = true;
  }, toggleTime);
}

//#endregion

//#region 定时器

const rebuildInterval = () => { // 销毁定时器，重新记时
  if (timer.value) {
    clearInterval(timer.value)
    timer.value = null;
  }
  runInterval();
}
const timer = ref<number | null>(null); // 创建定时器
const runInterval = () => { // 启动定时器
  timer.value = setInterval(() => {
    nextImg();
  }, 2500)
}

//#endregion


onUnmounted(() => {
  if (timer.value) {
    clearInterval(timer.value) // 组件销毁时清除定时器
    timer.value = null;
  }
})

onMounted(async () => {
  GetPopularDestination(); // 获取热门目的地州名和国家名
  GetPopularCountry(); // 获取热门目的地的图片与名字
  GetPopularAttractions(); // 获取热门景点的图片与名字
  GetPopularRoutes(); // 获取热门路线的图片与介绍
  runInterval(); // 启动定时器

})
//#region http

// 获取热门目的地州名和国家名
const GetPopularDestination = async () => {
  DestinationInfo.value = (await get<any>("BocaTripHome/GetPopularDestination")).data;
}
// 获取热门国家
const GetPopularCountry = async () => {
  Nations.value = (await get<any>("BocaTripHome/GetPopularCountry")).data;
}
// 获取热门景点的图片与名字
const GetPopularAttractions = async () => {
  Attractions.value = (await get<any>("BocaTripHome/GetPopularAttractions")).data;
}
// 获取热门路线的图片与介绍
const GetPopularRoutes = async () => {
  routes.value = (await get<any>("BocaTripHome/GetPopularRoutes?top=4&type=1")).data;
}

//#endregion



return (_ctx: any,_cache: any) => {
  const _component_DialogBoxSight = _resolveComponent("DialogBoxSight")!
  const _component_DialogBox = _resolveComponent("DialogBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "container-imgs",
          style: _normalizeStyle(imgStyle.value)
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(headerImgs)[_unref(headerImgs).length - 1].path
            }, null, 8, _hoisted_5)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerImgs), (i, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "imgs",
              key: index
            }, [
              _createElementVNode("img", {
                src: i.path,
                alt: ""
              }, null, 8, _hoisted_6)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _unref(headerImgs)[0].path
            }, null, 8, _hoisted_8)
          ])
        ], 4),
        _createElementVNode("div", {
          class: "previousImg",
          onClick: previousImg
        }, _hoisted_10),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerImgs).length, (i, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "toggleImgBtn",
              key: i,
              onClick: ($event: any) => (toggleImg(index)),
              style: _normalizeStyle(toggleImgBtnStyle(index))
            }, null, 12, _hoisted_12))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "nextImg",
          onClick: nextImg
        }, _hoisted_14)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DestinationInfo), (i, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex-col",
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(i.state), 1),
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.countrys, (n, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        onClick: ($event: any) => (_unref(jump)(_unref(router), 'ClassicTravelRoute', { code: 'country', countryName: n.cname, countryId: n.id }))
                      }, _toDisplayString(n.cname), 9, _hoisted_23))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Nations), (i, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "PopularCountry",
                key: index,
                style: _normalizeStyle({ backgroundImage: 'url(' + _unref(BASE_URL) + i.image1 + ')' }),
                onClick: ($event: any) => (_unref(jump)(_unref(router), 'ClassicTravelRoute', { code: 'country', countryName: i.cname, countryId: i.id }))
              }, [
                _createElementVNode("span", null, _toDisplayString(i.cname), 1)
              ], 12, _hoisted_25))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Attractions), (i, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (openAttractionDialog(i)),
              style: _normalizeStyle({ backgroundImage: 'url(' + _unref(BASE_URL) + (i.image1.includes('sight') ? '' : 'sight/') + i.image1 + ')' })
            }, [
              _createElementVNode("span", null, _toDisplayString(i.cname), 1)
            ], 12, _hoisted_30))
          }), 128))
        ])
      ]),
      _withDirectives(_createVNode(_component_DialogBox, { onClickClose: closeAttractionDialog }, {
        default: _withCtx(() => [
          _createVNode(_component_DialogBoxSight, { data: attractionData.value }, null, 8, ["data"])
        ]),
        _: 1
      }, 512), [
        [_vShow, attractionDialog.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _hoisted_34,
        _createElementVNode("div", {
          class: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(jump)(_unref(router), 'journeyCustom')))
        }, "立即定制")
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (i, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              title: i.croutetitle,
              onClick: ($event: any) => (_unref(jump)(_unref(router), 'JourneyDetail', { ...i }))
            }, [
              _createElementVNode("div", {
                class: "PopularRoutesImg",
                style: _normalizeStyle({ backgroundImage: `url(${i.imgpath ? `${_unref(BASE_URL)}` + (i.imgpath.includes('/') ? '' : 'camp/') +`${i.imgpath}` : require('../../assets/boka.jpg')})` })
              }, null, 4),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(i.croutetitle), 1)
              ])
            ], 8, _hoisted_39))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feature), (i, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("img", {
              src: i.imgUrl
            }, null, 8, _hoisted_44),
            _createElementVNode("p", null, _toDisplayString(i.text1), 1),
            _createElementVNode("span", null, _toDisplayString(i.text2), 1),
            _createElementVNode("span", null, _toDisplayString(i.text3), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})